import { createContext, useContext } from "react";

export type RegistrationSwitchProfileContextValue = {
  openSwitchProfile: () => void;
};

const noop = () => {};

export const RegistrationSwitchProfileContext =
  createContext<RegistrationSwitchProfileContextValue>({
    openSwitchProfile: noop,
  });

export function useRegistrationSwitchProfile(): RegistrationSwitchProfileContextValue {
  return useContext(RegistrationSwitchProfileContext);
}
